import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";

export const getUser = (email: any) => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/users`, {
				...AuthHeader,
				params: {
					filter: {
						email: { $regex: email, $options: "i" },
					},
				},
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const getUsers = (emailList: any) => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/users`, {
				...AuthHeader,
				params: {
					filter: {
						email: { $in: emailList },
					},
				},
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const getAllUsers = () => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/users`, {
				...AuthHeader,
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

// The signed-in user's own record. The server finds it from the sign-in
// itself, and creates it on a first sign-in.
export const getMe = () => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/users/me`, AuthHeader)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const updateUser = (userData: any) => {
	return new Promise((resolve, reject) => {
		axios
			.put(
				`${url}/users`,
				{
					filter: { email: userData.email },
					data: userData,
					options: { upsert: true, new: true },
				},
				AuthHeader
			)
			.then((_data: any) => {
				console.log(_data);
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

// The tenant the signed-in user last switched to, or null.
export const getLastTenant = () => {
	return new Promise<string | null>((resolve, reject) => {
		axios
			.get(`${url}/users/last-tenant`, AuthHeader)
			.then((_data: any) => {
				resolve(_data?.data?.tenantKey ?? null);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

// Remembers the tenant the signed-in user switched to. Gives up after 5 s,
// so a tenant switch never waits on it for long.
export const saveLastTenant = (tenantKey: string) => {
	return new Promise((resolve, reject) => {
		axios
			.put(
				`${url}/users/last-tenant`,
				{ tenantKey },
				{ ...AuthHeader, timeout: 5000 }
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
